module.exports = __webpack_public_path__ + "static/blog_grid_7-f74ea2743f7751706e089c4b4a16ad0e.jpg";